import {
    ICadastraEEditaVenda,
    IListVenda,
    IVenda,
    IVendaFilter,
} from "../../Interfaces/Geral/RegistraVenda/RegistraVendaInterface";
import Axios from "../Config/API";
import Service from "../Service";

export async function CadastrarVendaService(data: ICadastraEEditaVenda) {
    return Service(
        Axios.post(`/home/contaprodutosemerp/inserecontaprodutosemerp`, data)
    );
}

export async function ListarVendaService(
    page: number,
    quant: number,
    filter: IVendaFilter
) {
    return Service(
        Axios.post<IListVenda>(
            `/home/contaprodutosemerp/listcontaprodutosemerp?NR_PAGINA=${page}&QUANTIDADE=${quant}`,
            filter
        )
    );
}

export async function GetVendaService(idContaProduto: number) {
    return Service(
        Axios.get<IVenda>(
            `/home/contaprodutosemerp/getcontaprodutosemerp?ID_CONTA_PRODUTO=${idContaProduto}`
        )
    );
}

export async function EditarVendaService(
    data: ICadastraEEditaVenda,
    idContaProduto: number
) {
    return Service(
        Axios.put(
            `/home/contaprodutosemerp/updatecontaprodutosemerp?ID_CONTA_PRODUTO=${idContaProduto}`,
            data
        )
    );
}

export async function DeletarVendaService(idContaProduto: number) {
    return Service(
        Axios.delete(
            `/home/contaprodutosemerp/deletacontaprodutosemerp?ID_CONTA_PRODUTO=${idContaProduto}`
        )
    );
}

export async function AtualizarStatusService(
    idContaProduto: number,
    FL_STATUS: boolean
) {
    return Service(
        Axios.put(
            `/home/contaprodutosemerp/atualizastatusvenda?ID_CONTA_PRODUTO=${idContaProduto}&FL_STATUS=${FL_STATUS}`
        )
    );
}
